interface JoinBattleCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function JoinBattleCheckbox({ checked, onChange }: JoinBattleCheckboxProps) {
  return (
    <div className="smash-field smash-field--checkbox">
      <label className="smash-checkbox">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span>I am joining the battle!</span>
      </label>
    </div>
  );
}
